/**
 * Cliente do servico_score (services/score). Same-origin — sessao S2 via nginx
 * auth_request; POSTs levam X-Token injectado so no servidor.
 */
export class ScoreApiError extends Error {
  status: number
  constructor(status: number, message: string) {
    super(message)
    this.name = 'ScoreApiError'
    this.status = status
  }
}

async function apiJson<T>(path: string, init?: RequestInit): Promise<T> {
  const resp = await fetch(path, { credentials: 'include', ...init })
  if (!resp.ok) {
    const corpo = (await resp.json().catch(() => null)) as {
      erro?: string
      detail?: string
      message?: string
    } | null
    throw new ScoreApiError(
      resp.status,
      corpo?.erro ||
        (typeof corpo?.detail === 'string' ? corpo.detail : undefined) ||
        corpo?.message ||
        `Falha no servico de Score (HTTP ${resp.status}).`,
    )
  }
  return resp.json() as Promise<T>
}

/** Tenta a API; se falhar, cai no JSON estatico (contrato §4). */
export async function fetchScoreDados<T>(): Promise<T> {
  try {
    return await apiJson<T>('/api/score/dados')
  } catch {
    const resp = await fetch('/data/ml-score-anuncios.json', { credentials: 'include' })
    if (!resp.ok) throw new Error(`HTTP ${resp.status}`)
    return resp.json() as Promise<T>
  }
}

export function fetchScoreStatus(): Promise<Record<string, unknown>> {
  return apiJson('/api/score/status')
}

/** Dispara coleta completa (~25–35 min). Token só no nginx. */
export function dispararColetaScore(): Promise<{ ok: boolean; mensagem?: string }> {
  return apiJson('/api/score/coletar', { method: 'POST' })
}

/** Leitura/proposta da coleta — via bridge Hermes (mesma org Claude do Chat). */
export type ScoreAnalise = {
  ok: boolean
  coleta?: string
  gerado_em?: string
  modelo?: string
  texto?: string
  erro?: string
  error?: string
  message?: string
  fonte?: string
  runtime?: string
  cached?: boolean
}

export async function fetchScoreAnalise(): Promise<ScoreAnalise> {
  const resp = await fetch('/api/bridge/score/analise', {
    credentials: 'include',
    headers: { Accept: 'application/json' },
  })
  const data = (await resp.json().catch(() => ({}))) as ScoreAnalise
  if (!resp.ok && !data.ok) {
    return {
      ok: false,
      erro:
        data.erro ||
        data.message ||
        data.error ||
        `Falha na análise (HTTP ${resp.status}).`,
    }
  }
  return data
}
